import Typography from '@mui/material/Typography';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import Config from '@src/config/Config';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  id?: string;
  extension?: string;
  name?: string;
  email?: string;
  mobile?: boolean;
};

export const ContactCardContent: React.FC<Props> = ({
  id,
  extension,
  name,
  email,
  mobile = false,
}) => {
  const { t } = useTranslation();
  const userHasExtension = () => {
    return extension && extension.trim();
  };
  const getBrandExtension = () => {
    return Config.VITE_BRAND_EXTENSION
      ? ` ${t('extensionShort')} ${Config.VITE_BRAND_EXTENSION}`
      : '';
  };

  const getPhoneExtension = () => {
    return userHasExtension()
      ? ` ${t('extensionShort')} ${extension}`
      : getBrandExtension();
  };
  return (
    <Stack gap={theme.spacing[2]}>
      <Typography
        variant={mobile ? 'subtitle2' : 'body1'}
        style={mobile ? { fontWeight: 600 } : {}}
      >
        {t('agentContact.title')}
      </Typography>
      {id ? (
        <>
          <Stack>
            <Typography variant={mobile ? 'body1' : 'h6'}>{name}</Typography>
            <Typography>
              {Config.VITE_BRAND_PHONE}
              {getPhoneExtension()}
            </Typography>
          </Stack>
          <Stack>
            <Typography>
              <a
                href={`mailto:${email}`}
                style={{
                  textDecoration: 'none',
                  color: theme.palette.primary.primary,
                }}
              >
                {email}
              </a>
            </Typography>
            <Typography>
              <a
                href={`mailto:${Config.VITE_BRAND_EMAIL}`}
                style={{
                  textDecoration: 'none',
                  color: theme.palette.primary.primary,
                }}
              >
                {Config.VITE_BRAND_EMAIL}
              </a>
            </Typography>
          </Stack>
        </>
      ) : (
        <Typography variant="h6">{t('agentContact.noneAssigned')}</Typography>
      )}
    </Stack>
  );
};
